import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Box, Modal, Typography, TextField, Button } from '@mui/material';
import { Bert } from 'meteor/themeteorchef:bert';

const UserSharedModal = ({
  nameToEnter,
  setNameToEnter,
  userToSecondEnter,
  setUserToSecondEnter,
  openModal,
  setOpenModal,
  sharedUser
}) => {
  const [password, setPassword] = React.useState('');
  const [username, setUsername] = React.useState('');

  const modalStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const handleLogin = () => {
    if (!isEmpty(nameToEnter)) {
      setUserToSecondEnter({
        ...userToSecondEnter,
        name: nameToEnter
      });
      setOpenModal(false);
    } else {
      Bert.alert('Introduzca su nombre', 'info');
    }
  };

  return (
    <Modal open={openModal} onClose={() => setOpenModal(false)}>
      <Box sx={{ ...modalStyles }}>
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Ingresar
        </Typography>
        <TextField
          id="outlined-name"
          label="Ingrese su nombre"
          value={nameToEnter} // Usar nameToEnter para el valor del campo
          onChange={e => setNameToEnter(e.target.value)} // Actualizar nameToEnter al escribir
          fullWidth
        />
        {sharedUser && (
          <>
            <TextField
              id="outlined-username"
              label="Usuario"
              value={username}
              onChange={e => setUsername(e.target.value)}
              fullWidth
            />
            <TextField
              id="outlined-password"
              label="Contraseña"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              fullWidth
            />
          </>
        )}
        <Button variant="contained" onClick={handleLogin}>
          Ingresar
        </Button>
      </Box>
    </Modal>
  );
};

export default UserSharedModal;

UserSharedModal.defaultProps = {
  nameToEnter: '',
  setNameToEnter: () => {},
  openModal: false,
  setOpenModal: () => {},
  sharedUser: false
};

UserSharedModal.propTypes = {
  nameToEnter: PropTypes.string,
  setNameToEnter: PropTypes.func,
  userToSecondEnter: PropTypes.object.isRequired,
  openModal: PropTypes.bool,
  setOpenModal: PropTypes.func,
  setUserToSecondEnter: PropTypes.func.isRequired,
  sharedUser: PropTypes.bool
};
